/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type CreateBciTaxMutationVariables = Types.Exact<{
	input: Types.CreateBciTaxRequest;
}>;

export type CreateBciTaxMutation = {
	__typename?: "Mutation";
	createBciTax: {
		__typename: "CreateBciTaxResponse";
		code: string;
		isTaxable: boolean;
		taxWithheld?: {
			__typename?: "Tax";
			isTaxServiceAvailable: boolean;
			fiatId: string;
			assetId?: string | null;
			taxAmountFiat: { __typename?: "CurrencyAmount"; value: string };
			fiatAmountAfterTax?: { __typename?: "CurrencyAmount"; value: string } | null;
			taxAmountAsset?: { __typename?: "CurrencyAmount"; value: string } | null;
		} | null;
	};
};

export const CreateBciTaxDocument = gql`
	mutation createBciTax($input: CreateBciTaxRequest!) {
		createBciTax(request: $input) {
			__typename
			code
			taxWithheld {
				taxAmountFiat {
					value
				}
				isTaxServiceAvailable
				fiatId
				assetId
				fiatAmountAfterTax {
					value
				}
				taxAmountAsset {
					value
				}
			}
			isTaxable
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class CreateBciTaxGQLService extends Apollo.Mutation<CreateBciTaxMutation, CreateBciTaxMutationVariables> {
	document = CreateBciTaxDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
